import React, { ChangeEvent } from 'react';
import { FormControl, FormControlLabel, Checkbox, FormLabel, FormGroup } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import SearchField from '../Util/SearchField';
import DateRangePicker from '../Util/DateRangePicker';
import SelectRunStatus from '../Util/SelectRunStatus';
import SelectPitch from '../Util/SelectPitch';
import { RunState } from '../../api';
import { Moment } from 'moment';

interface Props {
  search?: string;
  onSearchChange: (val: string) => void;
  creationDateRange: { startDate: Moment | null; endDate: Moment | null };
  onCreationDateRangeChange: (arg: { startDate: Moment | null; endDate: Moment | null }) => void;
  runDateRange: { startDate: Moment | null; endDate: Moment | null };
  onRunDateRangeChange: (arg: { startDate: Moment | null; endDate: Moment | null }) => void;
  statuses: Array<RunState>;
  onStatusesChange: (newtypes: Array<RunState>) => void;
  completedOnly: boolean;
  onCompletedOnlyChange: (completedOnly: boolean) => void;
  pitches: { [key: string]: boolean };
  onPitchesChange: (pitches: { [key: string]: boolean }) => void;
}

const CompletedOnly = (props: { completedOnly: boolean; setCompletedOnly: any }) => {
  const onChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    props.setCompletedOnly(checked);
  };
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">Type</FormLabel>
      <FormGroup>
        <FormControlLabel
          control={<Checkbox checked={props.completedOnly} onChange={onChange} value={props.completedOnly} />}
          label="Completed runs only"
        />
      </FormGroup>
    </FormControl>
  );
};

const RunsFilter: React.FunctionComponent<Props> = (props) => {
  return (
    <div className="sciui-bg-p-4 sciui-m-y-m sciui-p-m">
      <div className="sciui-m-y-m">
        <Typography variant="h4">Filter</Typography>
      </div>
      <SearchField key="search" value={props.search} onChange={props.onSearchChange} />
      <DateRangePicker
        title="Creation date"
        value={props.creationDateRange}
        onChange={props.onCreationDateRangeChange}
      />
      <SelectRunStatus key="runtypes" statuses={props.statuses} onStatusesChange={props.onStatusesChange} />
      <CompletedOnly completedOnly={props.completedOnly} setCompletedOnly={props.onCompletedOnlyChange} />
      <DateRangePicker title="Run date" value={props.runDateRange} onChange={props.onRunDateRangeChange} />
      <SelectPitch pitches={props.pitches} onPitchesChange={props.onPitchesChange} />
    </div>
  );
};

export default RunsFilter;
